function jumpToSection() {
    var naSection = document.querySelector('.careers-list.abstract--na');
    var ukSection = document.querySelector('.careers-list.abstract--uk');

    if (naSection && getComputedStyle(naSection).display !== 'none') {
        naSection.scrollIntoView({ behavior: 'smooth' });
    } else if (ukSection && getComputedStyle(ukSection).display !== 'none') {
        ukSection.scrollIntoView({ behavior: 'smooth' });
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const button = document.getElementById('careerJumpButton');
    if (button) {
        button.addEventListener('click', jumpToSection);
    } else {
        document.body.addEventListener('click', function(event) { 
            if (event.target.id === 'careerJumpButton') {
                jumpToSection();
            }
        });
    }
});

